import invariant from "invariant";
import * as ChapterType from "utils/ChapterType";

const CONTEXTUAL_MENU_CAPTION_DICTIONARY = {
  [ChapterType.INTERVIEW]: "Make a Selection",
  [ChapterType.PATHFINDER]: "Find Path",
  [ChapterType.SLIDESHOW]: "Gallery View",
  [ChapterType.VIDEO]: "Interactive Content",
};

const MEDIA_TYPE_DICTIONARY = {
  [ChapterType.INTERVIEW]: "Question",
  [ChapterType.PATHFINDER]: "Path",
  [ChapterType.SLIDESHOW]: "Slide",
  [ChapterType.VIDEO]: "Video",
};

export function getContextualMenuCaption(chapterType) {
  invariant(
    Object.prototype.hasOwnProperty.call(
      CONTEXTUAL_MENU_CAPTION_DICTIONARY,
      chapterType,
    ),
    "Attempting to get contextual menu caption for non-existant chapter type `%s`. Defined chapter types are [%s]",
    chapterType,
    `'${Object.keys(CONTEXTUAL_MENU_CAPTION_DICTIONARY).join("', '")}'`,
  );

  return CONTEXTUAL_MENU_CAPTION_DICTIONARY[chapterType];
}

export function getMediaType(chapterType) {
  return MEDIA_TYPE_DICTIONARY[chapterType];
}
